import { combineReducers } from 'redux';

export const createRootReducerFactory = (syncReducers) => {
  return function (asyncReducers) {
    return combineReducers({
      ...syncReducers,
      ...asyncReducers
    });
  };
};

export const injectReducerFactory = (createRootReducer) => {
  return function (store, { key, reducer }) {
    if (Object.hasOwnProperty.call(store.asyncReducers, key)) return;

    store.asyncReducers[key] = reducer;
    store.replaceReducer(createRootReducer(store.asyncReducers));
  };
};
